// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsHeaderStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader";
import { css } from "styled-components";

rfqQuoteDetailsHeaderStyles.headerGridContainer = {
    gap: 0,
};

rfqQuoteDetailsHeaderStyles.title = {
    variant: "h3",
    as: "h1",
    css: css`
        margin-bottom: 20px;
        @media print {
            font-size: 11px;
        }
    `,
};

rfqQuoteDetailsHeaderStyles.buttonsHiddenContainer = {
    below: "lg",
    css: css`
        display: flex;
    `,
};

rfqQuoteDetailsHeaderStyles.deleteQuoteButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
};
